import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {environment} from '../../environments/environment';
import { forkJoin, Observable, Subject, Subscription, switchMap } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LinkexService {
  private cancelSubject: Subject<void> = new Subject<void>();
  private currentRequestSubscription: Subscription | null = null;
  private url = `${environment.apiUrl}/api/v1`;
  private pointServiceUrl = environment.pointServiceUrl
  public trackingHistory:any = {}
  constructor(private httpClient: HttpClient) { }

  contactUs(body:any){
    return this.httpClient.post(this.url+'/contactus', body);
  }
  getQuotes(body:any){
    return this.httpClient.post(this.url+'/rateQuote', body);
  }
  submitWarehouseQuestionnaire(body:any){
    return this.httpClient.post(this.url+'/warehouse-questionnaire', body);
  }
  submitTruckloadRateQuotes(body:any){
    return this.httpClient.post(this.url+'/rateQuote/truckload', body);
  }
  submitExpeditedRateQuotes(body:any){
    return this.httpClient.post(this.url+'/rateQuote/expedited', body);
  }
  submitFinalMileCartageRateQuotes(body:any){
    return this.httpClient.post(this.url+'/rateQuote/finalMileAndCartage', body);
  }
  submitInternationalRateQuotes(body:any){
    return this.httpClient.post(this.url+'/rateQuote/international', body);
  }
  submitDrayageTransloadingRateQuotes(body:any){
    return this.httpClient.post(this.url+'/rateQuote/drayageTransloading', body);
  }
  submitFinalMileQuestionnaire(body:any){
    return this.httpClient.post(this.url+'/finalMileAndWhiteGloveQuestionnaire', body);
  }
  validateSaiaAccount(body:any){
    return this.httpClient.post(this.url+'/validate-customer', body);
  }
  submitLiveRateQuotesRequest(body:any){
    return this.httpClient.post(this.url+'/liveRateQuote', body);
  }
  submitTenderRequest(body:any): any {
		return this.httpClient.post(this.url+'/quote-tendering', body);
  }
  trackShipment(body:any){
    return this.httpClient.post(this.url+'/tracking', body);
  }
  emailQuote(body:any){
    return this.httpClient.post(this.url+'/email-quote', body);
  }
  skipWeekendHoliday(body:any){
    return this.httpClient.post(this.url+'/skip-weekend-holiday', body);
  }
  getPreviousQuote(body:any){
    return this.httpClient.post(this.url+'/load-quote', body);
  }
  downloadFile(fileUrl:string): any {
		return this.httpClient.get(fileUrl, {responseType: 'blob'});
  }
  searchPointByCityZip(queryString: string, token:string){
   
    // Unsubscribe from the previous request before making a new one
    if (this.currentRequestSubscription) {
      this.currentRequestSubscription.unsubscribe();
    }


    // Switch to a new observable (API request) when a new request is triggered
    this.currentRequestSubscription = this.cancelSubject.pipe(
      switchMap(() => {
        if(environment.production) {
          const headers = new HttpHeaders({
            'xsrf-token': token
          });
          return this.httpClient.get(this.pointServiceUrl+'/point/search-by?'+ queryString, {headers:headers});
        } else {
          return this.httpClient.get(this.pointServiceUrl+'/point/search-by?'+ queryString);
        }
      })
    ).subscribe({
      next: (data) => {
        // console.log('Data received:', data);
      },
      error: (error) => {
        // console.error('Error:', error);
      },
      complete: () => {
        // console.log('Request completed');
      },
    });

    // Emit a cancel event to trigger the new request
    this.cancelSubject.next();
     if(environment.production) {
      const headers = new HttpHeaders({
        'xsrf-token': token
      });
      return this.httpClient.get(this.pointServiceUrl+'/point/search-by?'+ queryString, {headers:headers});
    } else {
      return this.httpClient.get(this.pointServiceUrl+'/point/search-by?'+ queryString);
    }
  }


  validatePoints(queryString: string, token: string){
    if(environment.production) {
      const headers = new HttpHeaders({
        'xsrf-token': token
      });
      return this.httpClient.get(this.pointServiceUrl+'/point?'+queryString, {headers:headers});
    } else {
      return this.httpClient.get(this.pointServiceUrl+'/point?'+queryString);
    }
  }

  validateOriginDestinationpointsData(originQs: string, destinationQs: string, token: string): Observable<any> {
    const origin = this.validatePoints(originQs, token);
    const destination = this.validatePoints(destinationQs, token);;

    // forkJoin will wait for both API calls to finish and then emit their results
    return forkJoin([origin, destination]);
  }
  surfPoints():Observable<HttpResponse<any>>{
    return this.httpClient.get(this.pointServiceUrl+'/surf',{observe: 'response', withCredentials: true,});
  }
}
